// extracted by css-extract-rspack-plugin
export default {"cls1":"CitingSourcesCard-cls1_GZv","cls2":"CitingSourcesCard-cls2_MsG CitingSourcesCard-cls1_GZv"};